
import { VueAgile } from 'vue-agile';

export default {
    components: {
        agile: VueAgile,
    },
    data() {
        return {
            imgs: [],
            visible: false,
            index: 0,
            options: {
                navButtons: false,
                dots: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                ],
            }
        }
    },
    methods: {
        show(index) {
            this.index = index
            this.visible = true
        }
    },
    props: {
        lightboxGallery: {
            type: Array,
            default: () => []
        },
        heading: {
            type: String,
            default: String,
        },
    },
    mounted() {
        this.imgs = this.lightboxGallery.map(image => image.image ? image.image : image)
    },
}
